module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C1657"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('span', {
    attrs: {
      "id": "page_v"
    }
  }, [_vm._v("CONTENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "C1659"
  }, [_c('em', [_c('a', {
    attrs: {
      "href": "#/html/05_Preface#page_vii"
    }
  }, [_vm._v("Preface")])]), _c('span', {
    staticClass: "small"
  }, [_vm._v("BY JAMES R. AKERMAN")])]), _vm._v(" "), _c('p', {
    staticClass: "C1667"
  }, [_c('a', {
    attrs: {
      "href": "#/html/06_Introduc#page_1"
    }
  }, [_vm._v("Introduction")]), _vm._v(" "), _c('em', [_vm._v("by Richard J. A. Talbert")])]), _vm._v(" "), _c('p', {
    staticClass: "C1660"
  }, [_c('a', {
    attrs: {
      "href": "#/html/07_1__The_E#page_9"
    }
  }, [_vm._v("1. The Expression of Terrestrial and Celestial Order in Ancient Mesopotamia")]), _vm._v(" "), _c('em', [_vm._v("by Francesca Rochberg ")])]), _vm._v(" "), _c('p', {
    staticClass: "C1667"
  }, [_c('span', {
    attrs: {
      "href": "#/html/08_2__From#page_43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. From Topography to Cosmos: Ancient Egypt’s Multiple Maps")]), _vm._v(" "), _c('em', [_vm._v("by David O’Connor ")])]), _vm._v(" "), _c('p', {
    staticClass: "C1667"
  }, [_c('span', {
    attrs: {
      "href": "#/html/09_3__Mappi#page_81",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Mapping the World: Greek Initiatives from Homer to Eratosthenes")]), _vm._v(" "), _c('em', [_vm._v("by Georgia L. Irby ")])]), _vm._v(" "), _c('p', {
    staticClass: "C1667"
  }, [_c('span', {
    attrs: {
      "href": "#/html/10_4__Ptole#page_109",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Ptolemy’s Geography: Mapmaking and the Scientific Enterprise")]), _vm._v(" "), _c('em', [_vm._v("by Alexander Jones ")])]), _vm._v(" "), _c('p', {
    staticClass: "C1667"
  }, [_c('span', {
    attrs: {
      "href": "#/html/11_5__Greek#page_129",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Greek and Roman Surveying and Surveying Instruments")]), _vm._v(" "), _c('em', [_vm._v("by Michael Lewis ")])]), _vm._v(" "), _c('p', {
    staticClass: "C1667"
  }, [_c('span', {
    attrs: {
      "href": "#/html/12_6__Urbs#page_163",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. "), _c('em', [_vm._v("Urbs Roma ")]), _vm._v("to "), _c('em', [_vm._v("Orbis Romanus")]), _vm._v(": Roman Mapping on the Grand Scale")]), _vm._v(" "), _c('em', [_vm._v("by Richard J. A. Talbert ")])]), _vm._v(" "), _c('p', {
    staticClass: "C1667"
  }, [_c('span', {
    attrs: {
      "href": "#/html/13_7__Putti#page_193",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. Putting the World in Order: Mapping in Roman Texts")]), _vm._v(" "), _c('em', [_vm._v("by Benet Salway ")])]), _vm._v(" "), _c('p', {
    staticClass: "C1660"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/html/notes#note",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "C1647"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/html/14_Bibliogr#page_234",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])])]), _vm._v(" "), _c('p', {
    staticClass: "C1647"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/html/15_Contribu#page_251",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Contributors")])])]), _vm._v(" "), _c('p', {
    staticClass: "C1647"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/html/16_Index#page_253",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])]), _vm._v(" "), _c('p', {
    staticClass: "C1647"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/html/plate",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Plate Section")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f1842bf2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/04_Contents.vue
// module id = 66
// module chunks = 0